import script from "./SongEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./SongEditor.vue?vue&type=script&setup=true&lang=js"

import "./SongEditor.vue?vue&type=style&index=0&id=1c4d4f8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4d4f8f"]])

export default __exports__